import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementOrganizationsRolesAction} from '../action';

function* execute({payload}: SearchManagementOrganizationsRolesAction): SagaIterator {
    yield* put(adminAction.setLoading('getRoles', true));
    const response = yield* call(Api.searchUserRolesForOrganization, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOrganizationsRoles(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getRoles', false));
}

/** Runs the admin saga that searches roles for the organization-management form. */
export function* searchManagementOrganizationsRolesSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_ORGANIZATIONS_ROLES', execute);
}
